export const config = {
    list: {
        selector: '.GoogleTranslate__options',
        activeClass: 'GoogleTranslate__options--active'
    },
    activeItem: {
        selector: '.GoogleTranslate__active-item',
        activeClass: 'GoogleTranslate__active-item--open'
    }
}